<script setup lang="ts">
defineProps<{
  // 施工例番号
  sekou_cd: number;
  // 施工例画像番号
  num?: number;
  // 一覧でみたとき何番目の画像か
  index?: number;
  //TODO: これは計算可能なので削除するかも
  img_path: string;
  // 施工例画像のalt
  title_1: string;
  title_2: string;
  area_1: string;
  area_2: string;
  comment?: string;
}>();

// 施工例詳細のURLを生成する
function detailPath(sekou_cd: number, imgnum: null | number = null) {
  let path = `/sekou/detail/${sekou_cd.toString().padStart(8, "0")}`;
  // 1はデフォルトの画像なので、URLには反映しないでおく
  if (imgnum && 1 < imgnum) {
    path += `_${imgnum.toString().padStart(2, "0")}`;
  }
  return path;
}
</script>

<template>
  <ListResponsiveItem class="relative" :rounded="true">
    <NuxtLink :to="detailPath(sekou_cd, num)">
      <ImageEl
        provider="customimgproxy"
        class="w-full rounded-t-lg mb-2"
        :src="img_path"
        :alt="title_1"
        :loading="index && 3 < index ? 'lazy' : 'eager'"
        :loadingAnimation="true"
        width="500"
        height="375"
        sizes="350px sm:600px md:350px lg:350px"
        format="webp"
      />
      <slot />
    </NuxtLink>
    <FavoriteToggleButton
      class="absolute z-[1] top-1 right-1 p-1"
      :item="{
        cd: sekou_cd.toString(),
        img_path: img_path,
        num: num,
        title_1: title_1,
        title_2: title_2,
        area_1: area_1,
        area_2: area_2,
        comment: comment,
      }"
    />
    <slot name="outer" />
  </ListResponsiveItem>
</template>
